import FileSaver from 'file-saver';

angular.module('TInv.util', []
).factory('FileUtil', function ($window, $q) {
    function b64toBlob(b64Data, contentType) {
        var chars = $window.atob(b64Data),
            len = chars.length,
            bytes = new Array(len);
        for (var i = 0; i < len; ++i)
            bytes[i] = chars.charCodeAt(i);
        return new Blob([new Uint8Array(bytes)], { type: contentType });
    }
    var me = {};
    me.save = function (blob, name) {
        FileSaver.saveAs(blob, name);
    };
    me.saveB64 = function (b64, mime, name) {
        me.save(b64toBlob(b64, mime), name);
    };
    me.saveWSDL = function (node, mime) {
        if ('Contenuto' in node)
            me.saveB64(node.Contenuto.toString(), mime, node.Nome);
        else if ('Attachment' in node)
            me.saveB64(node.Attachment.toString(), mime, node.NomeAttachment);
        else
            throw new Error('Unknown data.');
    };
    me.saveXML = function (xml, name) {
        me.save(new Blob([xml], { type: 'application/xml;charset=utf-8' }), name);
    };
    me.reader = function (file) {
        return $q(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function () {
                reject(reader.error);
            };
            reader.readAsText(file);
        });
    };
    me.readAsBuffer = function (file) {
        return $q(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function () {
                reject(reader.error);
            };
            reader.readAsArrayBuffer(file);
        });
    };
    return me;
}).factory('NaturalSort', function () {
    // inspired from http://jsfiddle.net/wE7H2/3/
    function padding(value) {
        return '00000000000000000000'.slice(value.length);
    }
    function normalized(value) {
        if (typeof value !== 'string')
            return value;
        // First, look for anything in the form of d.d or d.d.d...
        return value.replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
            // If there's more than 2 sets of numbers...
            if (decimal !== $3) {
                // treat as a series of integers, like versioning,
                // rather than a decimal
                return $0.replace(/(\d+)/g, function ($d) {
                    return padding($d) + $d;
                });
            } else {
                // add a decimal if necessary to ensure decimal sorting
                decimal = decimal || '.0';
                return padding(integer) + integer + decimal + padding(decimal);
            }
        }).replace(/[ _-]+/, ' '); // don't differentiate between different separators
    }
    return {
        value: normalized,
        compare: function(a, b) {
            a = normalized(a);
            b = normalized(b);
            return (a < b) ? -1 : ((a > b) ? 1 : 0);
        }
    };
}).factory('pollingFactory', function ($timeout) {
    var timeIntervalInSec = 60;
    function callFnOnInterval(fn, timeInterval) {
        var promise = $timeout(fn, 1000 * timeIntervalInSec);
        return promise.then(function(){
            callFnOnInterval(fn, timeInterval);
        });
    }
    return {
        callFnOnInterval: callFnOnInterval
    };
}).factory('delayed', function ($timeout) {
    // calls a function with a delay, which is re-triggered if it is called again before the call was done
    return function (delay, fn, skipApply) {
        var timer = null;
        return function () {
            var params = [ fn, delay, !skipApply ];
            if (arguments.length)
                params = params.concat([].slice.call(arguments));
            $timeout.cancel(timer);
            timer = $timeout.apply(null, params);
        };
    };
}).factory('checkPartitaIVA', function () {
    return function (pi) {
        if (!pi)
            return false;
        if (pi.length != 11)
            return false; // wrong length
        var s = 0;
        for (var i = 0; i < 11; ++i) {
            var v = pi.charAt(i) - '0';
            if (v < 0 || v > 9)
                return false; // invalid characters
            if ((i & 1) > 0) {
                v *= 2;
                if (v > 9)
                    v -= 9;
            }
            s += v;
        }
        s %= 10;
        return (s == 0);
    };
});
